import React from "react";
import Seo from "../components/Seo";
import "../styles/pages/service-detail.css";

function ChildrensServices() {
    return (
        <main className="page">
            <Seo
                title="Children's Services"
                path="/services/childrens-services"
                description="Safeguarding-led children's services designed around development, wellbeing, emotional support, and positive outcomes."
                keywords="children's services, child wellbeing support, safeguarding services, child centred care"
            />

            <div className="container service-detail">
                <div className="service-hero-card">
                    <p className="eyebrow">Children’s Services</p>
                    <h1>Safeguarding-led support designed around children’s wellbeing</h1>
                    <p>
                        Our children’s services are shaped around safeguarding, development, emotional wellbeing, and practical support for positive outcomes.
                    </p>
                </div>
                <div className="info-card">
                    <h2>Our Approach</h2>
                    <p>
                        We provide child-focused support that respects individual needs and promotes security, growth, stability, and positive development in every setting.
                    </p>
                </div>
            </div>
        </main>
    );
}

export default ChildrensServices;